import React from 'react'

export default function Services() {
  return (
    <div className='services'>
    <h1>Going to Add Services soon...</h1>
    </div>
  )
}
